import checkJwtToken from './checkJwtToken';

export default () => {
   checkJwtToken();
};
